import React, { useCallback, useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';

import { FieldDisplay } from './utils';

import { useRootSelector } from 'common/features/featuresReducer';
import { RootState } from 'rootStore';
import { getAccount } from 'common/api/users/service';

export const UserNameFieldDisplay = ({ isEditing, id }: { isEditing: boolean; id: string }) => {
    const profile = useRootSelector((state: RootState) => state.store.home.homeDetails?.profile);
    const shouldDisable = !profile?.email;
    const [userName, setUserName] = useState<string | null>(null);

    const fetchUsername = useCallback(async () => {
        const res = await getAccount();
        if (res.data) {
            setUserName(res.data.username);
        }
    }, []);

    useEffect(() => {
        fetchUsername();
    }, [fetchUsername, profile?.email]);

    return (
        <FieldDisplay
            id={id}
            label="Username"
            isEditing={isEditing}
            renderers={{
                ToggleEditViewRenderer: () => null,
            }}
        >
            {userName || <Skeleton className="h-10" />}
            {shouldDisable && <Skeleton className="h-10" />}
        </FieldDisplay>
    );
};
